import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CartControlFormGroup, ConfigurationsFormGroup } from '../../cart-control-form.component';
import { CheckoutExtensionUI } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { capitalize } from '@utils/string-utils';

@Component({
  selector: 'cart-control-form-configurations',
  templateUrl: './cart-control-form-configurations.component.html',
  styleUrl: './cart-control-form-configurations.component.scss',
  standalone: false,
})
export class CartControlFormConfigurationsComponent {
  @Input() formGroup: FormGroup<CartControlFormGroup>;
  @Input() shopCurrencySymbol: string;

  Appearances = Object.values(CheckoutExtensionUI.Appearance);
  appearanceToDisplayText = (value: string) => capitalize(value);

  get configurationsGroup(): FormGroup<ConfigurationsFormGroup> {
    return this.formGroup.get('configurations') as FormGroup<ConfigurationsFormGroup>;
  }
}
